import { Dispatch, SetStateAction } from "react";

export enum FormAccess {
  VIEW = "View",
  EDIT = "Edit",
  CREATE = "Create",
  DELETE = "Delete",
}

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  streetNumber: string;
  streetName: string;
  city: string;
  vicPostalCode: string;
  contactNumber: string;
  unitNumber: string;
  suburb: string;
  state: string;
  registeredUser: boolean;
  accountVerified: boolean;
};

// id: string;
//   firstName: string;
//   lastName: string;
//   email: string;
//   password: string;
//   streetNumber: string;
//   streetName: string;
//   city: string;
//   vicPostalCode: string;
//   contactNumber: string;
//   unitNumber: string;
//   suburb: string;
//   state: string;
//   registeredUser: boolean;
//   accountVerified: boolean;

export type UserModalDetailsType = {
  id: string | undefined;
  type: FormAccess;
};

export type UserRowType = User & {
  setCentered?: Dispatch<SetStateAction<boolean>>;
  modalDetails?: Dispatch<SetStateAction<UserModalDetailsType | undefined>>;
};

export interface CompanyRoleTableActionTypes {
  id: string;
  modalDetails?: Dispatch<SetStateAction<UserModalDetailsType | undefined>>;
  setCentered?: Dispatch<SetStateAction<boolean>>;
}

export type GetByIdUserRenseponse = {
  data: User;
  error: string;
};

export type GetUsersRenseponse = {
  data: User[];
  error: string;
};
